


<div class="mb-3 mt-2">
    <div class=" container-fluid">
<div class="row titlename">
  <div class="col-md-12 head-top">
    <h1 class="bannerTitle mb-0">{{ widgetTitle }} <span></span></h1>
  </div>
</div>
</div>
</div>
<div class="page-wrapper p-3">
    <div class="container-fluid">
        <div class="row mt-2">
<!-- <div *ngIf="widgetTitle" class="relative bg-gradient-to-r from-gray-200 rounded-full  mb-3 pt-2 pb-2 pl-3  "><h3 class="text-lg relative w-full font-semibold m-0 ">{{widgetTitle}} </h3></div> -->
            <!-- <div class="col-md-12 mb-4 ">
                <div class="note">Please fill out the below information as a family shares it with you over the phone or via email. 
                <br> Note: We are not telling families we are calculating their competing scholarship options. This tool is to help inform your conversation.</div>
            </div> -->
            <div class="col-md-12 mb-4 mt-1">
                <!-- <form id="form"> -->
                    <!-- [ngClass]="widgetno==2?'col-xl-12 col-md-12 mb-3 px-4': 'col-xl-6 col-md-6 mb-3 px-4'" -->
                    <div class="row">
                            <div *ngFor="let qus of calculatedQuestionArray"  [ngClass]="getClassforAutoSearch(qus)"  class="col-xl-6 col-md-6 mb-3 px-4">
                            <div class="form-group row">
                                <div class="col-sm-12 fm-row" >
                                    <ng-container>
                                            <lib-virtue-form 
                                                [inputWidget]="qus" 
                                                (validated)="formValid($event)" 
                                                (errorInput)="errorInput($event)" 
                                                (addInput)="changeinput($event)" 
                                                (removeInput)="removeinput($event)"
                                                [widgetno]="widgetno"
                                                [showError]="showError"
                                                [configId]="getConfigId(qus)"
                                                [value]="getValue(qus)"
                                                [altValue]="getaltValue(qus)"
                                                (disabled)="getDisabled(qus)">
                                            </lib-virtue-form>
                                    </ng-container>
                            </div>
                        </div>
                    </div>
                <!-- </form> -->
            </div>
        </div>
    </div>
</div>

